import { render } from "./singlepkt.vue?vue&type=template&id=5e486dde"
import script from "./singlepkt.vue?vue&type=script&lang=js"
export * from "./singlepkt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__